import React from "react";
import * as Styled from "./styles";
import { useClinicalBudget } from "shared/providers/ClinicalBudget";

const BudgetItems: React.FC = () => {
  const { 
    budgetItems, 
    removeItem, 
    formatMoeda,
    showValues,
    getElementoLabel,
  } = useClinicalBudget();

  const formatElemento = (elem: number, faces?: string): string => {
    const label = getElementoLabel(elem);
    if (faces) return `${label} (${faces})`;
    return label;
  };

  if (budgetItems.length === 0) {
    return (
      <Styled.EmptyState>
        <span className="icon">🦷</span>
        <p>Nenhum procedimento adicionado</p>
      </Styled.EmptyState>
    );
  }

  const handleRemove = (id: string) => {
    if (window.confirm('Deseja remover este procedimento do orçamento?')) {
      removeItem(id);
    }
  };

  return (
    <Styled.ItemsTable>
      <Styled.Table>
        <thead>
          <tr>
            <th>Procedimento</th>
            <th className="center">Elem.</th>
            {showValues && <th className="right">Valor</th>}
            <th className="center">Qtd</th>
            {showValues && <th className="right">Total</th>}
            <th className="center">Ação</th>
          </tr>
        </thead>
        <tbody>
          {budgetItems.map(item => (
            <tr key={item.id}>
              <td>
                <Styled.ProcNome>
                  {item.procNome}
                  {item.grupoNome && (
                    <span className="grupo">({item.grupoNome})</span>
                  )}
                  {item.faces && (
                    <span className="faces">Faces: {item.faces}</span>
                  )}
                  {item.obsPersonalizado && (
                    <span className="obs" title={item.obsPersonalizado}>
                      📝 {item.obsPersonalizado.length > 30 
                        ? item.obsPersonalizado.substring(0, 30) + '...' 
                        : item.obsPersonalizado}
                    </span>
                  )}
                </Styled.ProcNome>
              </td>
              <td className="center">
                <Styled.ElementoBadge>
                  {formatElemento(item.elemento, item.faces)}
                </Styled.ElementoBadge>
              </td>
              {showValues && (
                <td className="right">
                  <Styled.Valor showValue={showValues}>
                    R$ {formatMoeda(item.valor)}
                  </Styled.Valor>
                </td>
              )}
              <td className="center">{item.qtde}</td>
              {showValues && (
                <td className="right">
                  <Styled.Valor showValue={showValues}>
                    R$ {formatMoeda(item.valor * item.qtde)}
                  </Styled.Valor>
                </td>
              )}
              <td className="center">
                <Styled.RemoveButton onClick={() => handleRemove(item.id)}>
                  Remover
                </Styled.RemoveButton>
              </td>
            </tr>
          ))}
        </tbody>
      </Styled.Table>
    </Styled.ItemsTable>
  );
};

export { BudgetItems };
